import React from 'react';

export const SampleDetailPage = (props) => {
  return (
    <article className='sample-page'>
      <span>sample detail</span>
    </article>
  );
};
